import {
  sortNodesByHeadAndTail,
  sortActionsTypes,
} from "@/util/workflowDetails";
import cloneDeep from 'lodash/cloneDeep';

const setNodes = ({ commit, rootGetters, getters }, { actions = {} }) => {
  let nodes = [];

  if (actions && Object.keys(actions).length > 0) {
    const customer = rootGetters['customer/CUSTOMER'];
    const { data_source_name } = customer.CustomersFeature;

    const startSettings = getters['START_SETTINGS'];
    const trigger_type = startSettings.trigger_type;
    const actionTypes = sortActionsTypes(data_source_name, trigger_type);
    nodes = sortNodesByHeadAndTail(actions, actionTypes);
  }
  commit('SET_NODES', nodes);
  commit('SET_COPY_OF_SAVED_NODES_NODES', cloneDeep(nodes));
};

export default setNodes;
